import * as serverRequest from "common/utils/serverRequest";
import * as serverPaths from "common/utils/serverPaths";
//-------------------------------------------------------------------------------------------------------------------------------
// Login
//-------------------------------------------------------------------------------------------------------------------------------
export function async_getUserDataStartUp(dispatch) {
    return serverRequest.getPageJson(dispatch, serverPaths.getUserData())
        .then((response) => response.json().then((json) => Promise.resolve(json), (error) => Promise.reject("Unknown error interpreting response")), (error) => {
        if (error.status == serverRequest.ResponseStatus.noContent) {
            return Promise.reject(false);
        }
        else {
            return Promise.reject(true);
        }
    });
}
